import { ApiError } from './ApiError.ts';

export const IDV_REQUIRED_COPY =
  'This option requires identity verification. Please complete IDV in the Dorsia app before booking on the widget.';

export function getApiErrorCode(err: unknown): string | null {
  if (err instanceof ApiError) {
    const code = (err.response as unknown as Record<string, unknown>)?.error_code;
    return typeof code === 'string' ? code : null;
  }
  return null;
}

export function getIdvErrorCopy(err: unknown): string | null {
  return getApiErrorCode(err) === 'IDV_REQUIRED' ? IDV_REQUIRED_COPY : null;
}
